export const uiCursor = {
  interactive:
    "cursor-pointer disabled:cursor-default data-[disabled]:cursor-default",
  text:
    "cursor-text disabled:cursor-not-allowed",
  menuItem:
    "cursor-pointer data-[disabled]:cursor-default",
  passive:
    "cursor-default",
} as const;

